// Traduções da aba Cobrança Não atendimento (29/10/2026). Coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'viagens.aba.cobrancaNaoAtendimento': 'Cobrança Não atendimento',
    'viagens.cna.count_one': '{{count}} carga a cobrar do cliente',
    'viagens.cna.count_other': '{{count}} cargas a cobrar do cliente',
    'viagens.cna.hint': 'Cargas encerradas na Frente como Não atendido com a Cobrança Sim, pela data da carga. Serviço e Status ERP não recortam esta aba.',
    'viagens.cna.vazio': 'Nenhuma carga Não atendido com cobrança no período',
    'viagens.cna.situacao.a_cobrar': 'A cobrar',
    'viagens.cna.situacao.cobrado': 'Cobrado',
    'viagens.cna.situacao.recebido': 'Recebido',
    'viagens.cna.filtro.situacao': 'Situação da cobrança',
    'viagens.cna.kpi.cargas_zero': 'Nenhuma carga',
    'viagens.cna.kpi.cargas_one': '{{count}} carga',
    'viagens.cna.kpi.cargas_other': '{{count}} cargas',
    'viagens.cna.grupo.naoAtendimento': 'Não atendimento',
    'viagens.cna.grupo.cobranca': 'Cobrança',
    'viagens.cna.col.data': 'Data HUB',
    'viagens.cna.col.carga': 'Carga',
    'viagens.cna.col.cliente': 'Cliente',
    'viagens.cna.col.contrato': 'Contrato',
    'viagens.cna.col.motorista': 'Motorista',
    'viagens.cna.col.placa': 'Placa',
    'viagens.cna.col.carreta': 'Carreta',
    'viagens.cna.col.motivo': 'Motivo',
    'viagens.cna.col.observacao': 'Observação',
    'viagens.cna.col.valor': 'Valor da diária',
    'viagens.cna.col.cobrado': 'Cobrado',
    'viagens.cna.col.recebido': 'Recebido',
    'viagens.cna.encerrada': 'Encerrada em {{quando}} por {{quem}}',
    'viagens.cna.marcado': 'Em {{quando}} por {{quem}}',
    'viagens.cna.alguem': 'alguém',
    'viagens.cna.valor.rotulo': 'Valor da diária da carga {{carga}}',
    'viagens.cna.valor.invalido': 'Digite o valor em reais, maior que zero',
    'viagens.cna.salvo.valor': 'Valor da diária salvo',
    'viagens.cna.salvo.cobrado.sim': 'Carga marcada como Cobrado',
    'viagens.cna.salvo.cobrado.nao': 'Carga desmarcada de Cobrado',
    'viagens.cna.salvo.recebido.sim': 'Carga marcada como Recebido',
    'viagens.cna.salvo.recebido.nao': 'Carga desmarcada de Recebido',
    'viagens.cna.export.dica': 'Baixa as cargas da aba com os filtros aplicados, todas as páginas',
    'viagens.cna.export.vazio': 'Nenhuma carga no filtro para baixar',
  },
  en: {
    'viagens.aba.cobrancaNaoAtendimento': 'Unserved billing',
    'viagens.cna.count_one': '{{count}} load to bill the customer',
    'viagens.cna.count_other': '{{count}} loads to bill the customer',
    'viagens.cna.hint': 'Loads closed in the Front as Not served with Billing Yes, by the load date. Service and ERP status do not filter this tab.',
    'viagens.cna.vazio': 'No Not served load with billing in the period',
    'viagens.cna.situacao.a_cobrar': 'To bill',
    'viagens.cna.situacao.cobrado': 'Billed',
    'viagens.cna.situacao.recebido': 'Received',
    'viagens.cna.filtro.situacao': 'Billing status',
    'viagens.cna.kpi.cargas_zero': 'No load',
    'viagens.cna.kpi.cargas_one': '{{count}} load',
    'viagens.cna.kpi.cargas_other': '{{count}} loads',
    'viagens.cna.grupo.naoAtendimento': 'Not served',
    'viagens.cna.grupo.cobranca': 'Billing',
    'viagens.cna.col.data': 'HUB date',
    'viagens.cna.col.carga': 'Load',
    'viagens.cna.col.cliente': 'Customer',
    'viagens.cna.col.contrato': 'Contract',
    'viagens.cna.col.motorista': 'Driver',
    'viagens.cna.col.placa': 'Plate',
    'viagens.cna.col.carreta': 'Trailer',
    'viagens.cna.col.motivo': 'Reason',
    'viagens.cna.col.observacao': 'Note',
    'viagens.cna.col.valor': 'Daily rate',
    'viagens.cna.col.cobrado': 'Billed',
    'viagens.cna.col.recebido': 'Received',
    'viagens.cna.encerrada': 'Closed on {{quando}} by {{quem}}',
    'viagens.cna.marcado': 'On {{quando}} by {{quem}}',
    'viagens.cna.alguem': 'someone',
    'viagens.cna.valor.rotulo': 'Daily rate of load {{carga}}',
    'viagens.cna.valor.invalido': 'Type the amount in reais, above zero',
    'viagens.cna.salvo.valor': 'Daily rate saved',
    'viagens.cna.salvo.cobrado.sim': 'Load marked as Billed',
    'viagens.cna.salvo.cobrado.nao': 'Load unmarked as Billed',
    'viagens.cna.salvo.recebido.sim': 'Load marked as Received',
    'viagens.cna.salvo.recebido.nao': 'Load unmarked as Received',
    'viagens.cna.export.dica': 'Downloads the tab loads with the applied filters, all pages',
    'viagens.cna.export.vazio': 'No load in the filter to download',
  },
  es: {
    'viagens.aba.cobrancaNaoAtendimento': 'Cobro No atendido',
    'viagens.cna.count_one': '{{count}} carga a cobrar al cliente',
    'viagens.cna.count_other': '{{count}} cargas a cobrar al cliente',
    'viagens.cna.hint': 'Cargas cerradas en el Frente como No atendido con Cobro Sí, por la fecha de la carga. Servicio y Estado ERP no filtran esta pestaña.',
    'viagens.cna.vazio': 'Ninguna carga No atendido con cobro en el período',
    'viagens.cna.situacao.a_cobrar': 'Por cobrar',
    'viagens.cna.situacao.cobrado': 'Cobrado',
    'viagens.cna.situacao.recebido': 'Recibido',
    'viagens.cna.filtro.situacao': 'Situación del cobro',
    'viagens.cna.kpi.cargas_zero': 'Ninguna carga',
    'viagens.cna.kpi.cargas_one': '{{count}} carga',
    'viagens.cna.kpi.cargas_other': '{{count}} cargas',
    'viagens.cna.grupo.naoAtendimento': 'No atendido',
    'viagens.cna.grupo.cobranca': 'Cobro',
    'viagens.cna.col.data': 'Fecha HUB',
    'viagens.cna.col.carga': 'Carga',
    'viagens.cna.col.cliente': 'Cliente',
    'viagens.cna.col.contrato': 'Contrato',
    'viagens.cna.col.motorista': 'Conductor',
    'viagens.cna.col.placa': 'Placa',
    'viagens.cna.col.carreta': 'Remolque',
    'viagens.cna.col.motivo': 'Motivo',
    'viagens.cna.col.observacao': 'Observación',
    'viagens.cna.col.valor': 'Valor de la diaria',
    'viagens.cna.col.cobrado': 'Cobrado',
    'viagens.cna.col.recebido': 'Recibido',
    'viagens.cna.encerrada': 'Cerrada el {{quando}} por {{quem}}',
    'viagens.cna.marcado': 'El {{quando}} por {{quem}}',
    'viagens.cna.alguem': 'alguien',
    'viagens.cna.valor.rotulo': 'Valor de la diaria de la carga {{carga}}',
    'viagens.cna.valor.invalido': 'Escriba el valor en reales, mayor que cero',
    'viagens.cna.salvo.valor': 'Valor de la diaria guardado',
    'viagens.cna.salvo.cobrado.sim': 'Carga marcada como Cobrado',
    'viagens.cna.salvo.cobrado.nao': 'Carga desmarcada de Cobrado',
    'viagens.cna.salvo.recebido.sim': 'Carga marcada como Recibido',
    'viagens.cna.salvo.recebido.nao': 'Carga desmarcada de Recibido',
    'viagens.cna.export.dica': 'Descarga las cargas de la pestaña con los filtros aplicados, todas las páginas',
    'viagens.cna.export.vazio': 'Ninguna carga en el filtro para descargar',
  },
}
